import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'common/react/components/select';

import { statComparisonNavSelector } from 'store/modules/statspro/stat-comparison/selectors';
import { STATS_CATEGORY_ARRAY } from '../../../common/config/categories';
import { getTranslation } from 'common/react/utils/translations';
import { statComparisonActions } from 'common/store/modules/statspro/stat-comparison';

export const CategoryNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(statComparisonNavSelector);

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={STATS_CATEGORY_ARRAY}
                className="w-100"
                initialSelectedItem={nav.category}
                isReadyToRender={() => true}
                itemToString={(item) => item}
                icon="player-stats"
                type="with-default"
                activeItem={nav.category}
                label={getTranslation('label.statsLeaders.nav.category')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        statComparisonActions.setNavItem({
                            navItem: 'category',
                            value: selectedItem
                        })
                    );
                }}
                hideLabel
            />
        </div>
    );
};
